import React from "react";
import "./style.scss";

const UnderConstruction = () => {
  return (
    <div className="under-construction">
      <div className="uc-card">
        <h1>🚧 Site Under Construction</h1>
        <p>We’re working hard to bring you something amazing.</p>
        <button className="btn-2-white"><a href="/">Back to Home</a></button>
      </div>
    </div>
  );
};

export default UnderConstruction;
